import ReactDOM from "react-dom/client";
import { MantineProvider } from "@mantine/core";

import Header from "./components/Header";
import Dashboard from "./components/Dashboard";
import Footer from "./components/Footer";

import '@mantine/core/styles.css';

function App() {
  return (
    <MantineProvider defaultColorScheme="light">
        <Header />
        <Dashboard />
        <Footer />
    </MantineProvider>
  );
}

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(<App />);
